import React, { useState, useEffect } from 'react';
import { ProgressBar } from 'primereact/progressbar';
import { dictionary } from '../../dictionary';

const DaysToEndOfMonth = () => {
    const [daysToEnd, setDaysToEnd] = useState(0);
    const [progress, setProgress] = useState(100);

    const calculateDaysToEnd = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = now.getMonth();
        
        // Ostatni dzień bieżącego miesiąca
        const endOfMonth = new Date(year, month + 1, 0);
        const totalDaysInMonth = endOfMonth.getDate();
        
        // Różnica w dniach
        const differenceInTime = endOfMonth.getTime() - now.getTime();
        const differenceInDays = Math.ceil(differenceInTime / (1000 * 60 * 60 * 24));
        
        // Obliczanie procentu (ile dni zostało z całości miesiąca)
        const progressLeft = (differenceInDays / totalDaysInMonth) * 100;
        
        setDaysToEnd(differenceInDays);
        setProgress(progressLeft);
    };

    useEffect(() => {
        calculateDaysToEnd();
        const interval = setInterval(calculateDaysToEnd, 1000 * 60 * 60 * 24);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="days-counter-wrapper">
            <p>
                {dictionary.user_logs_table_month_counter1} 
                <span> {daysToEnd} </span> 
                {dictionary.user_logs_table_month_counter2}
            </p>
            <ProgressBar 
                value={progress.toFixed(0)} 
                showValue={false} 
                className="month-progress"
            />
        </div>
    );
};

export default DaysToEndOfMonth;